export default __webpack_public_path__ + "static/media/logo.3cce2a2f.svg";